<template>
  <sb-fullscreen-template
    class="distribution-modal-container"
    @close="editWroClosed"
  >
    <inventory-transfers-root />
  </sb-fullscreen-template>
</template>
<script>

import InventoryTransfersRoot from '../../micro-front-ends/InventoryTransfers/InventoryTransfersRoot.vue'

export default {
  name: 'EditTransferPlanModal',
  components: {
    InventoryTransfersRoot
  },
  methods: {
    editWroClosed () {
      this.$router.back()
    }
  }
}
</script>
<style lang="scss" scoped>
  .distribution-modal-container {
    .sb-fullscreen-template-content-wrapper {
        width: 100%;
        height: 100%;
        div:first-child {
          width: inherit;
          height: inherit;
        }
    }
  }
</style>
